import Vue from 'vue'
import Vuex from 'vuex'

import storeConfig from './storeConfig';
import storeForm from './storeForm.js';


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    form: storeForm,
    config: storeConfig,
  }
})

